import sortArray from "sort-array";

export function removeDuplicates<T extends object>(data: T[]): T[] {
  const keys = (data: T) => Object.keys(data).map(k => data[k]).join("|");

  return data.filter((function (set) {
    return function (o) {
      return (function (k) {
        if(!set.has(k)) {
          set.add(k);
          return true;
        }
        return false;
      })(keys(o));
    };
  })(new Set())
)}

interface SortOptions { by?: string; order?: "asc"|"desc", orderArray?: string [] };
export function sort<T>(array: T[], sortOptions?: SortOptions): T[] {
  if(sortOptions?.by && sortOptions?.orderArray) {
    return _orderSort(array, sortOptions as OrderSortOptions);
  } else { 
    return sortArray(array, sortOptions);
  }
}

interface OrderSortOptions extends SortOptions { by: string; orderArray: string [] };
function _orderSort<T>(array: T[], options: OrderSortOptions) {
  const { by, order, orderArray } = options;

  /*return array.sort((a, b) => {
    const indexA = orderArray.indexOf(a[by]);
    const indexB = orderArray.indexOf(b[by]);
  
    // Handle cases where an item is not in the order array
    // Place items not in the order array at the end by assigning them a high index
    const orderA = indexA === -1 ? orderArray.length : indexA;
    const orderB = indexB === -1 ? orderArray.length : indexB;
  
    return ((order === "desc") ? orderB - orderA : orderA - orderB);
  });*/

  /*
   * Alternative: Create a map for better performance
   * For larger arrays, repeatedly calling indexOf() can be inefficient. 
   * A more performant approach is to create a map of the order array first.
   */

  // Create a map from the order array for faster lookups
  const orderMap = orderArray.reduce((map, value, index) => {
    map[value] = index;
    return map;
  }, {});

  return array.sort((a, b) => ((order === "desc") 
    ? orderMap[b[by]] - orderMap[a[by]]
    : orderMap[a[by]] - orderMap[b[by]]
  ));
}
